import React from "react";
import {
  Button,
  Collapse,
  Card,
  CardContent,
  Grid,
  Box,
  Typography,
} from "@mui/material";
import {
  Person as PersonIcon,
  Business as BusinessIcon,
  Event as EventIcon,
  AccessTime as AccessTimeIcon,
} from "@mui/icons-material";

const InfoRow = ({ icon: Icon, label, value }) => (
  <>
    <Box display="flex" alignItems="center" mb={1}>
      <Icon />
      <Typography variant="h6" ml={1}>
        {label}
      </Typography>
    </Box>
    <Typography variant="body1" gutterBottom marginLeft={4}>
      {value || "-"}
    </Typography>
  </>
);

const InfoCard = ({ isOpen, toggle, approvelist }) => (
  <>
    <Collapse in={isOpen}>
      <Card variant="outlined" sx={{ marginTop: 2 }}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <InfoRow
                icon={PersonIcon}
                label="Employee ID"
                value={approvelist.empId}
              />
              <InfoRow
                icon={PersonIcon}
                label="Employee Name"
                value={approvelist.employeeName}
              />
              <InfoRow
                icon={PersonIcon}
                label="Employee Dept"
                value={approvelist.employeeDept}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <InfoRow
                icon={BusinessIcon}
                label="Approver ID"
                value={approvelist.appliedTo}
              />
              <InfoRow
                icon={BusinessIcon}
                label="Approver Name"
                value={approvelist.approverName}
              />
              <InfoRow
                icon={BusinessIcon}
                label="Approver Dept"
                value={approvelist.approverDept}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <InfoRow
                icon={EventIcon}
                label="Applied Date"
                value={approvelist.appliedDate}
              />
              <InfoRow
                icon={AccessTimeIcon}
                label="No of Days"
                value={approvelist.noOfDays}
              />
              <InfoRow
                icon={EventIcon}
                label="Regularization Dates"
                value={
                  approvelist.regularizationDates
                    ? approvelist.regularizationDates.join(", ")
                    : "-"
                }
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Collapse>
  </>
);

export default InfoCard;
